import React from 'react';
import RewardDeliveryAddress from './reward-delivery-address';

const Reward = (props) => {
  const {
    image, name, redeemed, available, nextAmount,
    address1, address2, address3, eircode, individualBalance,
    transferAmount, hasStaffMembers
  } = props;

  return (
    <div className="my-rewards-info-container">
      <div className="my-rewards-image-container">
        <img className="my-rewards-image" src={image} alt={name} />
      </div>
      <div className="my-rewards-info">
        <div className="my-rewards-info-row">
          <p className="my-rewards-info-key">CURRENT VOUCHER:</p>
          <p className="my-rewards-info-value">{name}</p>
        </div>
        <div className="my-rewards-info-row">
          <p className="my-rewards-info-key">NO. OF VOUCHERS RECEIVED:</p>
          <p className="my-rewards-info-value">{`${redeemed}/${available}`}</p>
        </div>
        <div className="my-rewards-info-row">
          <p className="my-rewards-info-key">FUNDS AVAILABLE TO REDEEM:</p>
          <p className="my-rewards-info-value">{nextAmount == -1 ? 'This outlet has reached its redemption limit and cannot redeem any more points for this reward period' : `€${nextAmount}`}</p>
        </div>
        <div>
          <div className="my-rewards-info-row">
            <p className="my-rewards-info-key">FUNDS AVAILABLE TO TRANSFER:</p>
            <p className="my-rewards-info-value">{`€${transferAmount}`}</p>
          </div>
          {redeemed === available &&  <div className="my-rewards-info-row">
            <div className="my-rewards-info-text">
              You have reached your two vouchers per person limit for the year, you have <span className="my-rewards-info-currency">€{transferAmount}</span> balance which you can transfer to a staff member.
            </div>
          </div>}
        </div>
        <RewardDeliveryAddress
          address1={address1}
          address2={address2}
          address3={address3}
          eircode={eircode}
          hasStaffMembers={hasStaffMembers}
        />
      </div>
    </div>
  );
}

export default Reward;



// WEBPACK FOOTER //
// ./src/components/my-rewards/reward.jsx